<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.promoCode.title.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="promoCode.title"
                      />

                      <form-error
                        :model="$v.promoCode.title"
                        label="Naziv"
                        :dirty="$v.promoCode.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">B2B/B2C</label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="promoCode.businessType"
                        :options="b2bOrb2cOptions"
                        :disabled="true"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Tip popusta</label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="promoCode.discountApplianceType"
                        :options="discountTypes"
                        :disabled="true"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.promoCode.code.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Promo kod</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Promo kod"
                        v-model="promoCode.code"
                      />

                      <form-error
                        :model="$v.promoCode.code"
                        label="Promo kod"
                        :dirty="$v.promoCode.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.promoCode.limitationUsageNumber.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Limit upotrebe</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Limit upotrebe"
                        v-model.number="promoCode.limitationUsageNumber"
                      />

                      <form-error
                        :model="$v.promoCode.limitationUsageNumber"
                        label="Limit upotrebe"
                        :dirty="$v.promoCode.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.promoCode.discount.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Iznos popusta</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Iznos popusta"
                        v-model.number="promoCode.discount"
                      />

                      <form-error
                        :model="$v.promoCode.discount"
                        label="Iznos popusta"
                        :dirty="$v.promoCode.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.promoCode.startDate.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Vrijedi od</label>
                    <div class="col-lg-7 col-xl-6">
                      <datepicker
                        placeholder="Vrijedi od"
                        input-class="form-control form-control-modern bg-body"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                        v-model="promoCode.startDate"
                      ></datepicker>

                      <form-error
                        :model="$v.promoCode.startDate"
                        label="Vrijedi od"
                        :dirty="$v.promoCode.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.promoCode.endDate.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Vrijedi do</label>
                    <div class="col-lg-7 col-xl-6">
                      <datepicker
                        placeholder="Vrijedi do"
                        input-class="form-control form-control-modern bg-body"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                        v-model="promoCode.endDate"
                      ></datepicker>

                      <form-error
                        :model="$v.promoCode.endDate"
                        label="Vrijedi do"
                        :dirty="$v.promoCode.$dirty"
                      />
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>

                <!-- proizvodi -->
                <div v-if="promoCode.discountApplianceType == 2" class="col-9 position-relative">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                          >Pretraga artikala</label
                        >
                        <div class="col-lg-7 col-xl-6 pb-4 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle('getArticles')"
                            @blur="onBlurHandle"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="article in articles"
                              :key="article.id"
                              @click="addArticle(article)"
                            >
                              <div>
                                {{ article.title }}
                              </div>
                              <div>
                              Šifra: {{ article.code }}
                              </div>
                              <div v-if="promoCode.businessType == 1">
                                VPC: {{ article.vpc.toFixed(2).toString().replace('.', ',') }}
                              </div>
                              <div v-if="promoCode.businessType == 2">
                                MPC: {{ article.mpc.toFixed(2).toString().replace('.', ',') }}
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div
                          class="dataTables_wrapper dt-bootstrap5 no-footer"
                          v-if="
                            promoCode.articles &&
                            promoCode.articles.length > 0
                          "
                        >
                          <div class="table-responsive">
                            <table
                              class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                            >
                              <thead>
                                <tr role="row">
                                  <th class="sorting">Rbr</th>
                                  <th class="sorting">Naziv</th>
                                  <th class="sorting">Šifra</th>
                                  <th class="sorting">Redovna cijena</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  role="row"
                                  v-for="(
                                    item, index
                                  ) in promoCode.articles"
                                  :key="item.articleId"
                                  :class="{
                                    odd: index % 2 === 0,
                                    even: index % 2 !== 0,
                                  }"
                                >
                                  <td>
                                    <strong>{{ index + 1 }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.title }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.code }}</strong>
                                  </td>
                                  <td v-if="promoCode.businessType == 1">
                                    <strong>{{ item.vpc.toFixed(2).toString().replace('.', ',') }}</strong>
                                  </td>
                                  <td v-if="promoCode.businessType == 2">
                                    <strong>{{ item.mpc.toFixed(2).toString().replace('.', ',') }}</strong>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      class="btn"
                                      @click="deleteArticle(item)"
                                    >
                                      <i class="bx bx-trash text-4 me-2"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- kategorije -->
                <div v-if="promoCode.discountApplianceType == 3" class="col-9 position-relative">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                          >Pretraga kategorija</label
                        >
                        <div class="col-lg-7 col-xl-6 pb-4 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle('getCategories')"
                            @blur="onBlurHandle"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="item in categories"
                              :key="item.id"
                              @click="addCategory(item)"
                            >
                              <div>
                                {{ item.title }}
                              </div>
                             </li>
                          </ul>
                        </div>

                        <div
                          class="dataTables_wrapper dt-bootstrap5 no-footer"
                          v-if="
                            promoCode.categories &&
                            promoCode.categories.length > 0
                          "
                        >
                          <div class="table-responsive">
                            <table
                              class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                            >
                              <thead>
                                <tr role="row">
                                  <th class="sorting">Rbr</th>
                                  <th class="sorting">Naziv</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  role="row"
                                  v-for="(
                                    item, index
                                  ) in promoCode.categories"
                                  :key="item.categoryId"
                                  :class="{
                                    odd: index % 2 === 0,
                                    even: index % 2 !== 0,
                                  }"
                                >
                                  <td>
                                    <strong>{{ index + 1 }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.title }}</strong>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      class="btn"
                                      @click="deleteCategory(item)"
                                    >
                                      <i class="bx bx-trash text-4 me-2"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- brendovi -->
                <div v-if="promoCode.discountApplianceType == 4" class="col-9 position-relative">
                  <div class="form-group row align-items-center">
                    <div class="col">
                      <div class="form-group row pb-3">
                        <label
                          class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                          >Pretraga brendova</label
                        >
                        <div class="col-lg-7 col-xl-6 pb-4 position-relative">
                          <input
                            type="text"
                            class="search-term form-control"
                            placeholder="Pretraga"
                            v-model="searchField"
                            @input="onSearchHandle('getBrands')"
                            @blur="onBlurHandle"
                          />

                          <ul
                            class="article-list bg-body"
                            v-if="showSearchResults"
                          >
                            <li
                              v-for="item in brands"
                              :key="item.id"
                              @click="addBrand(item)"
                            >
                              <div>
                                {{ item.title }}
                              </div>
                             </li>
                          </ul>
                        </div>

                        <div
                          class="dataTables_wrapper dt-bootstrap5 no-footer"
                          v-if="
                            promoCode.brands &&
                            promoCode.brands.length > 0
                          "
                        >
                          <div class="table-responsive">
                            <table
                              class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                            >
                              <thead>
                                <tr role="row">
                                  <th class="sorting">Rbr</th>
                                  <th class="sorting">Naziv</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  role="row"
                                  v-for="(
                                    item, index
                                  ) in promoCode.brands"
                                  :key="item.brandId"
                                  :class="{
                                    odd: index % 2 === 0,
                                    even: index % 2 !== 0,
                                  }"
                                >
                                  <td>
                                    <strong>{{ index + 1 }}</strong>
                                  </td>
                                  <td>
                                    <strong>{{ item.title }}</strong>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      class="btn"
                                      @click="deleteBrand(item)"
                                    >
                                      <i class="bx bx-trash text-4 me-2"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3" exact
            :to="{ name: 'Coupons' }">
            {{ translations.cancel }}
          </router-link>
          <button type="submit"
            class="ubmit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { format } from 'date-fns';
import { debounce } from 'lodash';
import Datepicker from 'vuejs-datepicker';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';
import validations from "./validation-schema/add";
import FormError from "../shared/form-errors/FormError.vue";

import { translations } from '@/mixins';
import api from '@/services/api';

export default {
  name: 'EditPromoCode',
  mixins: [translations],
  data() {
    return {
      searchField: '',
      showSearchResults: false,
    };
  },
  validations: {
    promoCode: {
      ...validations,
    },
  },
  components: {
    Datepicker,
    Treeselect,
    FormError,
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
    bs() {
      return bs;
    },
    promoCode() {
      return this.$store.getters.getPromoCode;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
    discountTypes() {
      return [
        {
        id: 1,
        label: 'Popust se odnosi na iznos narudžbe',
      }, {
        id: 2,
        label: 'Popust se odnosi na proizvode',
      }, {
        id: 3,
        label: 'Popust se odnosi na kategorije',
      }, {
        id: 4,
        label: 'Popust se odnosi na brand'
      }];
    },
    b2bOrb2cOptions() {
      return [
        { id: 1, label: 'B2B' },
        { id: 2, label: 'B2C' },
      ];
    },
    id() {
      return parseInt(this.$route.params.type, 10)
    },
    articles() {
      var data = this.$store.getters.getArticles;
      return data.filter((x) => !this.promoCode.articles.map((a) => a.articleId).includes(x.id));
    },
    categories() {
      var data = this.$store.getters.getCategories;
      return data.filter((x) => !this.promoCode.categories.map((a) => a.categoryId).includes(x.id));
    },
    brands() {
      var data = this.$store.getters.getBrands;
      return data.filter((x) => !this.promoCode.brands.map((a) => a.brandId).includes(x.id));
    },
  },
  methods: {
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const { promoCode } = this;

      if(promoCode.discountApplianceType == 4) {
        promoCode.discountApplianceTypeIds = [];
        promoCode.discountApplianceTypeIds = promoCode.brands.map(item => item.brandId);
      }
      else if(promoCode.discountApplianceType == 3) {
        promoCode.discountApplianceTypeIds = [];
        promoCode.discountApplianceTypeIds = promoCode.categories.map(item => item.categoryId);
      }
      else if(promoCode.discountApplianceType == 2) {
        promoCode.discountApplianceTypeIds = [];
        promoCode.discountApplianceTypeIds = promoCode.articles.map(item => item.articleId);
      }

      api.updatePromoCode(promoCode)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Coupons' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    addArticle(article) {
      const { id, vpc, title, code, mpc } = article;

      const parsedArticle = {
        articleId: id,
        code,
        mpc,
        title,
        vpc,
      };

      const foundArticle = this.promoCode.articles.find(
        (item) => item.articleId === article.id
      );

      this.showSearchResults = false;
      this.searchField = '';

      if (foundArticle) {
        this.$toast.error('Artikal je već dodan.');
        return;
      }
      this.promoCode.articles.push(parsedArticle);
    },
    addCategory(category) {
      const { id, title } = category;

      const parsedCategory = {
        categoryId: id,
        title,
      };

      const foundCategory = this.promoCode.categories.find(
        (item) => item.categoryId === category.id
      );

      this.showSearchResults = false;
      this.searchField = '';

      if (foundCategory) {
        this.$toast.error('Kategorija je već dodata.');
        return;
      }
      this.promoCode.categories.push(parsedCategory);
    },
    addBrand(brand) {
      const { id, title } = brand;

      const parsedBrand = {
        brandId: id,
        title,
      };

      const foundBrand = this.promoCode.brands.find(
        (item) => item.brandId === brand.id
      );

      this.showSearchResults = false;
      this.searchField = '';

      if (foundBrand) {
        this.$toast.error('Brend je već dodat.');
        return;
      }
      this.promoCode.brands.push(parsedBrand);
    },
    onSearchHandle: debounce(function (actionName) {
      this.showSearchResults = true;
      this.$store.dispatch(actionName, {
        sortBy: 'title',
        isSortAscending: true,
        page: 1,
        retrieveAll: true,
        quickSearch: this.searchField.trim(),
      });
    }, 300),
    onBlurHandle: debounce(function () {
    }, 300),
    deleteArticle(article) {
      const index = this.promoCode.articles.findIndex(
        (item) => item.articleId === article.articleId
      );
      this.promoCode.articles.splice(index, 1);
    },
    deleteCategory(category) {
      const index = this.promoCode.categories.findIndex(
        (item) => item.categoryId === category.categoryId
      );
      this.promoCode.categories.splice(index, 1);
    },
    deleteBrand(brand) {
      const index = this.promoCode.brands.findIndex(
        (item) => item.brandId === brand.brandId
      );
      this.promoCode.brands.splice(index, 1);
    },
  },
  mounted() {
    this.$store.dispatch('getPromoCode', parseInt(this.$route.params.id, 10));

  },
};
</script>

<style lang="scss" scoped>
.position-relative {
  position: relative;
}

.article-list {
  position: absolute;
  margin-top: 3px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  list-style: none;
  padding: 0;
  z-index: 1;
  left: 12px;
  right: 12px;
  top: 40px;
  overflow-y: auto;
  max-height: 200px;

  li {
    display: block;
    border-top: 1px solid #ced4da;
    padding: 0 10px;
    cursor: pointer;
    overflow: hidden;

    &:first-child {
      border-top: none;
    }
  }
}

.card-articles {
  margin-bottom: 100px;
}

.date-picker-width {
    width: 100%;
}

.custom-vue-tree-select .vue-treeselect__control {
  border: 1px solid #e7e7e7;
}
</style>